import React from 'react'
import SideBarBack from '../../components/SidebarBack'
import { useDispatch } from 'react-redux'
import {
    setDrawerActiveMenu
} from '../../store/features/webUtilitiesSlice'
import men from '../../assets/images/reset/men.png'
import icon from '../../assets/images/reset/icon.png'

export default function Menu() {
    const dispatch = useDispatch()
    const handleCloseDrawer = async () => {
        await dispatch(setDrawerActiveMenu(31))
    }

    return (
        <div className='w-full h-full' >
            <div className='w-full flex mb-2'>
                <SideBarBack className="bg-transparent" handleCloseDrawer={handleCloseDrawer} />
            </div>
            <div className='flex justify-center items-center flex-col gap-2 mt-3 w-11/12 mx-auto pb-10'>
                <p className='text-2xl text-center font-medium'>Reset FastBetter & <br /> <span className='text-[#FF9950]'>start again</span> ?</p>
                <div className='flex gap-6 w-10/12'>
                    <img src={men} alt='workoutladey' />
                </div>
                <div className='cardbox text-center mt-3 relative w-full bg-[#FFBE251A] border border-[#FFBE25] shadow-md py-4 pt-6 px-6 rounded-3xl'>
                    <img
                        className='watchImg right-36 -top-5 w-9 h-9 absolute rounded-md'
                        alt='watchImg'
                        src={icon}
                    />
                    <div className='text-center'>
                        <p className='cardboxtitle text-sm'>
                            Are your sure?
                        </p>
                        <p className='text-[11px] mt-2'>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                        </p>
                    </div>
                </div>
                <div className='flex justify-center gap-6 w-full'>
                    <button className='bg-[#FF9950] text-white text-sm w-5/12 py-4 mt-6 rounded-2xl'>
                        Start again
                    </button>
                    <button onClick={handleCloseDrawer} className='bg-gray-200 border border-gray-200 text-black font-semibold text-sm w-5/12 py-4 mt-6 rounded-2xl'>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    )
}
